import * as React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
export const FormText = (props: any) => {
  const { name, label, validate, switchOnOffName, funcFormText } = props;

  const {
    control,
    register,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();

  const [textValue, setTextValue] = React.useState(getValues(name));
  const handleChange = (event: any) => {
    setTextValue(event.target.value);
    setValue(name, event.target.value);
    if (switchOnOffName) {
      setValue(switchOnOffName, !!event.target.value);
    }
    if (funcFormText) {
      funcFormText(event.target.value);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={validate}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          disabled={false}
          type="text"
          label={label}
          variant="outlined"
          error={!!errors[name]}
          helperText={(errors[name]?.message ?? "") as string}
          fullWidth
          margin="dense"
          value={getValues(name)}
          onChange={handleChange}
          // {...register(name)}
        />
      )}
    />
  );
};
